export const meta = {
  id: 'cycle-sort',
  name: 'Cycle Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²)',
    space: 'O(1)'
  },
  description: 'Cycle Sort is an in-place unstable sorting algorithm that minimizes the number of writes to the original array by rotating elements through cycles.'
};
